<template>
    <div class="container new-article knowledge-base-article-show">
        <div>
            <router-link class="go-back" :to="{ name: 'knowledgeBase' }">Повернутися до списку</router-link>
        </div>

        <div class="kb-article-show-wrap">
            <div class="col-lg-8 kb-article-show-content">
                <div class="kb-article-show-head">
                    <h1 class="kb-article-show-header">
                        {{ article.title }}
                    </h1>

                    <div v-if="article.createdTimeAgo && article.updatedTimeAgo" class="kb-show-dates">
                        <span class="kb-show-dates">
                            Створено {{ timeFromDates('createdTimeAgo') }}
                        </span>
                        <span style="font-size: 20px" class="kb-dot">&middot;</span>
                        <span class="">
                            Остання редакція {{ timeFromDates('updatedTimeAgo') }}
                        </span>
                    </div>

                    <div class="kb-show-tags">
                        <div class="kb-show-tags-list">
                            <div v-for="tag in article.tags" class="kb-show-tag">{{ tag.tag_name }}</div>
<!--                            <div v-if="article.tags.length" class="kb-show-tag">+1</div>-->
                        </div>
                    </div>

                </div>

                <div class="kb-article-show-body">
<!--                    <div>-->
<!--                        <img :src="article.previewImageUrl">-->
<!--                    </div>-->

                    <div>
                        <div v-html="article.content"></div>
                    </div>


                    <div class="kb-bottom-block">
                        <div class="publish-info">
                            <div class="author-place" v-if="article.author">
                                <span class="author-label">Автор статті: </span><span class="author-name">{{ article.author }}</span>
                            </div>
                            <div class="author-place date" v-if="article.publishedAt">
                                <span class="author-label">Опубліковано: </span><span>{{ article.publishedAt }}</span>
                            </div>
                        </div>
                        <div class="necessary-block">
                            <div class="necessary-label">Стаття була корисною ? </div>
                            <div class="necessary-likes">
                                <div class="necessary-icon" @click="setLike(1)">
                                    <svg :class="['kb-like', { 'active': userReaction }]" width="42px" height="42px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.2699 16.265L20.9754 12.1852C21.1516 11.1662 20.368 10.2342 19.335 10.2342H14.1539C13.6404 10.2342 13.2494 9.77328 13.3325 9.26598L13.9952 5.22142C14.1028 4.56435 14.0721 3.892 13.9049 3.24752C13.7664 2.71364 13.3545 2.28495 12.8128 2.11093L12.6678 2.06435C12.3404 1.95918 11.9831 1.98365 11.6744 2.13239C11.3347 2.29611 11.0861 2.59473 10.994 2.94989L10.5183 4.78374C10.3669 5.36723 10.1465 5.93045 9.86218 6.46262C9.44683 7.24017 8.80465 7.86246 8.13711 8.43769L6.69838 9.67749C6.29272 10.0271 6.07968 10.5506 6.12584 11.0844L6.93801 20.4771C7.0125 21.3386 7.7328 22 8.59658 22H13.2452C16.7265 22 19.6975 19.5744 20.2699 16.265Z" fill="#FFAD3D26" stroke="#FFAD3D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.96767 9.48508C3.36893 9.46777 3.71261 9.76963 3.74721 10.1698L4.71881 21.4063C4.78122 22.1281 4.21268 22.7502 3.48671 22.7502C2.80289 22.7502 2.25 22.1954 2.25 21.5129V10.2344C2.25 9.83275 2.5664 9.5024 2.96767 9.48508Z" fill="#FFAD3D26" stroke="#FFAD3D"/>
                                    </svg>
                                </div>
                                <div class="necessary-icon" @click="setLike(0)">
                                    <svg :class="['kb-dislike', { 'active': userReaction === 0}]" width="42px" height="42px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.2699 8.48505L20.9754 12.5648C21.1516 13.5838 20.368 14.5158 19.335 14.5158H14.1539C13.6404 14.5158 13.2494 14.9767 13.3325 15.484L13.9952 19.5286C14.1028 20.1857 14.0721 20.858 13.9049 21.5025C13.7664 22.0364 13.3545 22.465 12.8128 22.6391L12.6678 22.6856C12.3404 22.7908 11.9831 22.7663 11.6744 22.6176C11.3347 22.4539 11.0861 22.1553 10.994 21.8001L10.5183 19.9663C10.3669 19.3828 10.1465 18.8195 9.86218 18.2874C9.44683 17.5098 8.80465 16.8875 8.13711 16.3123L6.69838 15.0725C6.29272 14.7229 6.07968 14.1994 6.12584 13.6656L6.93801 4.27293C7.0125 3.41139 7.7328 2.75 8.59658 2.75H13.2452C16.7265 2.75 19.6975 5.17561 20.2699 8.48505Z" fill="#FFAD3D26" stroke="#FFAD3D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.96767 15.2651C3.36893 15.2824 3.71261 14.9806 3.74721 14.5804L4.71881 3.34389C4.78122 2.6221 4.21268 2 3.48671 2C2.80289 2 2.25 2.55474 2.25 3.23726V14.5158C2.25 14.9174 2.5664 15.2478 2.96767 15.2651Z" fill="#FFAD3D26" stroke="#FFAD3D"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="col-lg-4 kb-article-show-sidebar">
                <div class="kb-sidebar-box">
                    <div class="kb-similar-title">
                        Схожі статті
                    </div>
                    <div class="kb-similar-articles">
                        <div v-for="article in similarArticles" :key="article.id" class="kb-sidebar-similar">
                            <a :href="article.id" :key="article.id">
                                {{ article.title }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

// import preview from './components/preview';
import { show as showArticle, setArticleReaction } from '@/api/knowledgeBase';
// import previewLoader from './components/previewLoader';

export default {
    components: {
        // previewLoader,
        // preview
    },
    data: function () {
        return {
            condition: {
                isLoadArticle: true,
            },
            article: {},
            userReaction: false,
            similarArticles: [],
        }
    },
    created: async function() {
        //TODO сделать через Vuejs
        $('.router-section').append('<div class="router-preload"><div class="spinner"></div></div>');
        setTimeout(function(){
            $('.router-section .router-preload').remove();
        }, 600)

        let response = await showArticle(this.$route.params.id).catch(() => {
            this.$router.push('/prime')
        });

        if (response?.data?.data) {
            this.article = response.data.data.article;
            this.userReaction = response.data.data?.article?.userReaction?.reaction;
            this.similarArticles = response.data.data?.similarArticles;
        } else {
            this.$router.push('/prime')
        }
    },
    mounted () {
      window.scrollTo(0, 0)
    },

    methods: {
        timeFromDates(dateType) {
            const datesAgo = dateType == 'createdTimeAgo' ? this.article.createdTimeAgo : this.article.updatedTimeAgo;
            let dateAgoText = null;

            if (datesAgo.diffYears) {
                dateAgoText = datesAgo.diffYears < 5 ? (datesAgo.diffYears > 1 ? datesAgo.diffYears + ' роки' : datesAgo.diffYears + ' рік') : datesAgo.diffYears + ' років';
            } else if (datesAgo.diffMonths) {
                dateAgoText = datesAgo.diffMonths < 5 ? (datesAgo.diffMonths > 1 ? datesAgo.diffMonths + ' місяці' : datesAgo.diffMonths + ' місяць') : datesAgo.diffMonths + ' місяців';
            } else if (datesAgo.diffDays) {
                dateAgoText = datesAgo.diffDays < 5 ? (datesAgo.diffDays > 1 ? datesAgo.diffDays + ' дні' : datesAgo.diffDays + ' день') : datesAgo.diffDays + ' днів';
            }

            if (dateAgoText !== null) {
                dateAgoText = dateAgoText + ' тому';
            } else {
                dateAgoText = 'нещодавно';
            }

            return dateAgoText;
        },
        setLike(likeType) {
            const params = {
                articleId: this.$route.params.id,
                reaction: likeType,
            }

            setArticleReaction(params)
                .then(response => {
                    if (response.data.status === 'success') {
                        this.userReaction = likeType;
                        return true;
                    }
                })
                .catch(error => {
                    return false;
                });
        },

    }
}
</script>

<style lang="scss" scoped>
    .author {
        font-weight: 700;
        font-size: 18px;
        line-height: 27px;
        color: #24282c;
    }
    .banner-preview {
        border-radius: 5px;
        width: 100%;
        height: 300px;
        -o-object-fit: cover;
        object-fit: cover;
        -o-object-position: right bottom;
        object-position: right bottom;
    }
    .date {
        font-size: 18px;
    }
</style>
